import { Outlet } from "react-router-dom";
import axios from "axios";
import { API_ORIGIN } from "../../config/env";
import { getAuthHeaders } from "../../utils/auth";

export default function CommentsPage() {
  return <Outlet />;
}

/** Reuse existing video-interactions comments API. */
export function getCommentsByVideo(videoId, { page = 1, limit = 25 } = {}) {
  return axios.get(`${API_ORIGIN}/api/v1/video-interactions/comments/${videoId}`, {
    headers: getAuthHeaders(),
    params: { page, limit },
  });
}

export function updateComment(commentId, content) {
  return axios.put(
    `${API_ORIGIN}/api/v1/video-interactions/comments/${commentId}`,
    { content },
    { headers: getAuthHeaders() }
  );
}

export function deleteComment(commentId) {
  return axios.delete(`${API_ORIGIN}/api/v1/video-interactions/comments/${commentId}`, {
    headers: getAuthHeaders(),
  });
}

export function getVideoById(videoId) {
  return axios.get(`${API_ORIGIN}/api/v1/videos/single/${videoId}`, {
    headers: getAuthHeaders(),
  });
}
